(() => {
  const translations = new Map([
    ['Cookie consent', 'Cookie-Einstellungen'],
    ['Privacy Policy', 'Datenschutzerklärung'],
    ['Accept', 'Akzeptieren'],
    ['Accept all', 'Alle akzeptieren'],
    ['Decline', 'Ablehnen'],
    ['Decline all', 'Alle ablehnen'],
    ['Reject all', 'Alle ablehnen'],
    ['Manage preferences', 'Einstellungen verwalten'],
    ['Save preferences', 'Auswahl speichern'],
    ['Confirm my choices', 'Auswahl bestätigen'],
    ['Cookie preferences', 'Cookie-Einstellungen'],
    ['Preferences', 'Einstellungen'],
    ['Required', 'Erforderlich'],
    ['Always active', 'Immer aktiv'],
    ['Functional', 'Funktional'],
    ['Personalization', 'Personalisierung'],
    ['Advertising', 'Werbung'],
    ['Analytics', 'Analyse'],
    ['Marketing', 'Marketing'],
  ]);

  const privacyCopy = new Map([
    [
      'We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our',
      'Wir und unsere Partner, einschließlich Shopify, verwenden Cookies und andere Technologien, um Ihr Einkaufserlebnis zu personalisieren, Ihnen Werbung anzuzeigen und Analysen durchzuführen. Für diese Zwecke verwenden wir Cookies und andere Technologien nur mit Ihrer Einwilligung. Weitere Informationen finden Sie in unserer',
    ],
    [
      'We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them.',
      'Wir und unsere Partner, einschließlich Shopify, verwenden Cookies und andere Technologien, um Ihr Einkaufserlebnis zu personalisieren, Ihnen Werbung anzuzeigen und Analysen durchzuführen. Für diese Zwecke verwenden wir Cookies und andere Technologien nur mit Ihrer Einwilligung.',
    ],
    [
      'Learn more in our',
      'Weitere Informationen finden Sie in unserer',
    ],
    ['Privacy Policy', 'Datenschutzerklärung'],
  ]);

  function translateTextNode(node) {
    const original = node.nodeValue;
    const text = original.trim();
    const translation = translations.get(text);

    if (translation) {
      const start = original.indexOf(text);
      node.nodeValue = `${original.slice(0, start)}${translation}${original.slice(start + text.length)}`;
      return;
    }

    let translated = original;
    privacyCopy.forEach((replacement, source) => {
      translated = translated.replaceAll(source, replacement);
    });

    if (translated !== original) node.nodeValue = translated;
  }

  function translateTree(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (root.shadowRoot) translateTree(root.shadowRoot);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        translateTextNode(node);
      } else if (node.shadowRoot) {
        translateTree(node.shadowRoot);
      }
      node = walker.nextNode();
    }
  }

  document.documentElement.lang = 'de';
  translateTree(document.documentElement);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        translateTextNode(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(translateTree);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true,
  });
})();
